export const isManagementApi = (indicator) => /^https:\/\/[^.]+\.logto\.app\/api$/.test(indicator);
